/// <amd-module name="SuiteCommerce.GridOrder.Shopping"/>
define("SuiteCommerce.GridOrder.Shopping", ["require", "exports", "SuiteCommerce.GridOrder.Common.Configuration", "SuiteCommerce.GridOrder.PDP", "SuiteCommerce.GridOrder.Common.InstrumentationHelper"], function (require, exports, Configuration_1, PDP, InstrumentationHelper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            this.initializeConfiguration(environment);
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(environment);
            PDP.mountToApp(container);
        },
        initializeConfiguration: function (environment) {
            Configuration_1.Configuration.environment = environment;
        },
    };
});
